import path from 'path-browserify';
export function urlJoin(...parts: (string | undefined | null)[]) {
    const s = (parts.length === 1 && Array.isArray(parts[0]) ? parts[0] as any[] : parts) as string[];
    let r = "";
    for (let i = 0; i < s.length; i++) {
        let d = (s[i] ?? "").toString();
        if (!d) continue;
        if (i === 0) r = d;
        else {
            d = d.replace(/^\/+/, "");
            r = r.replace(/\/+$/, "");
            r = `${r}/${d}`;
        }
    }
    return r;
}

/**
 * Returns a full URL.
 * If partial_url is already absolute (starts with http), it is returned as is.
 * Otherwise, it is combined with the base URL.
 */
export function get_full_url(partial_url: any, domain: any = null) {
    if (typeof partial_url !== 'string') {
        throw new Error('partial_url must be a string');
    }
    // If it already starts with http, assume it is absolute.
    if (partial_url.startsWith('http')) {
        return partial_url;
    }
    return urlJoin(domain, partial_url);
}

/**
 * Returns a full file system path.
 * If partial_path is already absolute, it is returned as is.
 * Otherwise, it is joined with the base directory.
 */
export function get_full_path(partial_path: any, parent_dir: any = null) {
    if (typeof partial_path !== 'string') {
        throw new Error('partial_path must be a string');
    }
    if (path.isAbsolute(partial_path)) {
        return partial_path;
    }
    return urlJoin(parent_dir, partial_path);
}
/**
 * Converts a local file system path into its corresponding URL.
 * It checks against the known directories in all_paths and replaces the matching base.
 */
export function path_to_url(filePath: string, all_paths: any): string | null {
    if (typeof filePath !== 'string') {
        throw new Error('filePath must be a string');
    }
    for (const key in all_paths) {
        const mapping = all_paths[key as keyof typeof all_paths];
        const normalizedBase = path.normalize(mapping.path);
        if (filePath.startsWith(normalizedBase)) {
            const relativePath = filePath.substring(normalizedBase.length);
            return urlJoin(mapping.url, relativePath.replace(/\\/g, '/'));
        }
    }
    return null;
}
/**
 * Converts a URL into its corresponding local file system path.
 * It checks against the known URL prefixes in all_paths and replaces the matching base.
 */

export function url_to_path(urlStr: string, all_paths: any): string | null {
    if (typeof urlStr !== 'string') {
        throw new Error('urlStr must be a string');
    }
    for (const key in all_paths) {
        const mapping = all_paths[key as keyof typeof all_paths];
        if (urlStr.startsWith(mapping.url)) {
            const relativeUrl = urlStr.substring(mapping.url.length);
            return urlJoin(mapping.path, relativeUrl);
        }
    }
    return null;
}


export function urljoin(
	...parts: (string | undefined | null)[]
	) {
		return urlJoin(...parts);
	}
